import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRolesPermissions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0001 8.18286C7.21394 8.18286 3.32031 12.0765 3.32031 16.8626V20.0314C3.32031 22.1531 5.04644 23.8796 7.16819 23.8796H16.8319C18.9537 23.8796 20.6802 22.1531 20.6802 20.0314V16.8626C20.6798 12.0761 16.7858 8.18286 12.0001 8.18286ZM18.8048 20.031C18.8048 21.1189 17.9198 22.0042 16.8316 22.0042H7.16781C6.07994 22.0042 5.19494 21.1192 5.19494 20.031V16.8622C5.19494 13.11 8.24744 10.0575 11.9997 10.0575C15.7519 10.0575 18.8044 13.11 18.8044 16.8622L18.8048 20.031Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.57861 7.9046V5.66323C7.57861 3.64085 9.56199 1.99573 11.9999 1.99573C13.21 1.99573 14.3372 2.39398 15.1772 3.11998C15.9797 3.80735 16.4211 4.71073 16.4211 5.66323V7.9046C17.092 8.23723 17.7205 8.64223 18.2961 9.1106V5.66323C18.2961 4.1546 17.6219 2.74573 16.4001 1.69873C15.2226 0.681353 13.66 0.120728 11.9999 0.120728C8.52811 0.120728 5.70361 2.60698 5.70361 5.66323V9.1106C6.27886 8.64223 6.90774 8.23723 7.57861 7.9046Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0001 11.37C8.97156 11.37 6.50781 13.8337 6.50781 16.8622V20.031C6.50781 20.3955 6.80444 20.6917 7.16856 20.6917H16.8323C17.1968 20.6917 17.4931 20.3955 17.4931 20.031V16.8622C17.4923 13.8341 15.0286 11.37 12.0001 11.37ZM14.8594 15.6536L12.0293 18.4837C11.8463 18.6667 11.6063 18.7582 11.3663 18.7582C11.1263 18.7582 10.8863 18.6667 10.7033 18.4837L9.14069 16.9211C8.77431 16.5547 8.77431 15.9615 9.14069 15.5955C9.50669 15.2291 10.1007 15.2291 10.4663 15.5955L11.3659 16.4951L13.5334 14.328C13.8998 13.9616 14.4931 13.9616 14.8591 14.328C15.2251 14.6944 15.2254 15.288 14.8594 15.6536Z",
			fill: "currentColor"
		})
	]
});
export default SvgRolesPermissions;
